import { Component, Input, OnInit } from '@angular/core'

import { SESSION_STORAGE_CONSTANTS_CAAS_CONTENT } from '../../../../constants/constant.content'
import { NUMBER_ZERO } from '../../../../constants/constant.numbers'
import { FilterByModel } from '../../../models/filterby-model'
import { AbstractFilterProcess } from '../../../services/data-filters/abstract-filter-process'
import { ObservableService } from '../../../services/observable-service/observable.service'
import { FilterModel } from '../../../shared/filter-model'

@Component({
  selector: 'asset-class-strategy-filter',
  templateUrl: './asset-class-strategy-filter.component.html',
  styleUrls: ['./asset-class-strategy-filter.component.scss'],
})
export class AssetClassStrategyFilterComponent implements OnInit {
  @Input() filterByLabHeader
  filter
  filterByValue = ''
  selectedProductType: string
  validFilterByValue = false
  fd3popupsList: any
  strategiespopupHeader: any
  useContentWidth: false
  filterByLevel1Array = {
    equity: false,
    fixedIncome: false,
    multiAsset: false,
    cashEquivalent: false,
    factorDriven: false,
    esg: false,
    sectorSpecialties: false,
    dividend: false,
  }
  filterByModel: FilterByModel
  constructor(
    private filterModel: FilterModel,
    private observableService: ObservableService,
    private readonly filterProcess: AbstractFilterProcess,
  ) {}
  ngOnInit(): void {
    this.observableService.viewProductClickValue.subscribe((value) => {
      this.selectedProductType = value
    })
    this.filterModel.telecastFilterBy.subscribe((data) => {
      this.filter = data
    })
    this.parsePopupContent()
    this.observableService.rowRecordValue.subscribe(() => {
      this.filterByModel = this.filterProcess.getAvailableCategoryLvl1Names()
    })
  }

  onFilterByChange(event: any) {
    // reset the sub asset selection count to 0
    this.filterModel.setSubAssetSelectedCount(NUMBER_ZERO)
    if (
      event.radioGroupState.inputId !== '' &&
      Object.keys(this.filter.filterByLevel1).includes(
        event.radioGroupState.inputId,
      )
    ) {
      for (const filterByLevel1_Key in this.filter.filterByLevel1) {
        this.filter.filterByLevel1[filterByLevel1_Key].value =
          this.filterByLevel1Array[filterByLevel1_Key] =
            event.radioGroupState.inputId == filterByLevel1_Key
        this.clearPreviousSelectedSubAssetFilter(
          this.filter.filterByLevel1[filterByLevel1_Key].level2,
        )
      }
      this.observableService.filterBySelectedItem(event.radioGroupState)
      this.filter.isFilterByLevel1Clicked = this.filterModel.isTrue(
        this.filterByLevel1Array,
      )
      this.filter =
        this.filterModel.checkCollectiveTrustWithCashEquivalentScenario(
          this.selectedProductType,
          this.filter,
        )
      this.filterModel.editDataFilterBy(this.filter)
      this.filterByValue = event.radioGroupState.inputValue
      this.validFilterByValue = event.hasSelection
      this.observableService.viewFilterByClick(this.filterByValue)
    }
  }

  parsePopupContent() {
    const aemCassDataFromSession = sessionStorage.getItem(
      SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
    )
    const parsedCaasJson = JSON.parse(aemCassDataFromSession)
    this.strategiespopupHeader =
      parsedCaasJson.data.fd3popupsList.items[0]['strategiesHeader']
    this.fd3popupsList =
      parsedCaasJson.data.fd3popupsList.items[0].strategiespopup['html']
        .replaceAll('<br>', '')
        .replaceAll('<p>', '')
        .replaceAll('</p>', '')
  }

  clearPreviousSelectedSubAssetFilter(level2Filter: any) {
    if (!level2Filter) return
    level2Filter.forEach((element: any) => {
      element.value = false
    })
  }
}
